import { useQuery } from '@tanstack/react-query';

import { useHoofdstuk } from '../hoofdstuk';

type HoofdstukkenWithOverwegingProps = {
  besluitId: string;
};

/**
 * Returns a list of hoofdstukken that have an Inhoudelijke overweging
 */
const useHoofdstukkenWithOverweging = (
  props: HoofdstukkenWithOverwegingProps
) => {
  const overwegingHoofdstukken = useQuery(
    getHoofdstukkenWithOverwegingQueryOptions(props)
  );
  return overwegingHoofdstukken;
};

const getHoofdstukkenWithOverwegingQueryOptions = ({
  besluitId,
}: HoofdstukkenWithOverwegingProps) => {
  return useHoofdstuk.getOptions({
    page: 1,
    size: 100,
    filter: [
      {
        model: 'OverwegingHoofdstuk',
        field: 'Besluit',
        op: 'eq',
        value: besluitId,
      },
      {
        model: 'Hoofdstuk',
        field: 'Vorig',
        op: 'is_null',
        value: '',
      },
    ],
  });
};

useHoofdstukkenWithOverweging.getOptions =
  getHoofdstukkenWithOverwegingQueryOptions;
export { useHoofdstukkenWithOverweging };
